import React from 'react'
import styles from './styles.module.css'

export const Row = ({children, style}) => {
  return (
    <div className={styles.row} style={style}>{children}</div>
  )
}
